import React from "react";
import styles from "./BlueBtn.module.css";
import styled from "styled-components";
const BlueBtn = ({ children, onAtion, icon, bgColor, bgHover }) => {
  // ✅ اینجا داخل خود کامپوننته
  const Button = styled.div`
    background: ${(props) => props.bg || " var(--button-gradient)"};
    width: 100%;
    margin: 5px auto;
    font-size: 12px;
    border-radius: 2rem;
    display: flex;
    align-items: center;
    height: 45px;
    justify-content: center;
    box-shadow: 0px 1px 5px -1px black, inset 0px 0px 6px -5px black;
    background: ;
    transition: 500ms;
    font-family: bold;
    color: white;
    position: relative;

    &:hover {
      background: ${(props) =>
        props.hoverBg || " var(--button-gradient-hover)"};
      cursor: pointer;
    }
    &:active,
    &:focus-visible {
      background: ${(props) =>
        props.hoverBg || " var(--button-gradient-hover)"};
      cursor: pointer;
      transform: scale(0.9);
    }
    .&:focus {
      outline: none;
    }
  `;

  return (
    <Button
      bg={bgColor}
      hoverBg={bgHover}
      className={icon && styles.spaceadder}
      onClick={() => onAtion()}
    >
      {icon ? (
        <>
          <i className={icon}></i>
          <div className={styles.containonbtn}>{children}</div>
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default BlueBtn;
